import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';

import { MaterialCustomModule } from '../../material-custom.module';

import { DirectiveModule } from './../shared/directives/directive.module';

// COMPONENTS
import {
  UiEmptyPageComponent,
  UiInputComponent,
  UiButtonComponent,
  UiConfirmationDialogComponent,
  UiAlertComponent,
  UiIconComponent,
  UiWarningDialogComponent,
  UiInputConfirmationDialogComponent,
  UiInputButtonGroupComponent,
  UiVirtualCalculatorComponent,
  UiVirtualNumpadComponent,
  UiAutocompleteComponent,
  UiAdvanceSelectComponent,
  UiAutocompleteChipComponent,
  UiScannerComponent,
  UiLoadingDialogComponent,
  UiMessageDialogComponent,
  UiSelectAllAgGridComponent,
  UiLabelComponent,
  UiLocationConfirmDialog,
  UiTextareaComponent,
  UiModalComponent,
  UiPopoverComponent,
  UiFieldLabelComponent,
  UiDatepickerComponent,
  UiPullInboundShipmentsDialogComponent,
  UiMultipleConfirmationDialogComponent,
  UiFulfillmentActionConfirmationDialogComponent,
} from './components';

// LIB

// MODULES

const components = [
  UiEmptyPageComponent,
  UiInputComponent,
  UiButtonComponent,
  UiConfirmationDialogComponent,
  UiAlertComponent,
  UiIconComponent,
  UiWarningDialogComponent,
  UiInputConfirmationDialogComponent,
  UiInputButtonGroupComponent,
  UiVirtualCalculatorComponent,
  UiVirtualNumpadComponent,
  UiAutocompleteComponent,
  UiAdvanceSelectComponent,
  UiAutocompleteChipComponent,
  UiScannerComponent,
  UiLoadingDialogComponent,
  UiMessageDialogComponent,
  UiSelectAllAgGridComponent,
  UiLabelComponent,
  UiLocationConfirmDialog,
  UiTextareaComponent,
  UiModalComponent,
  UiPopoverComponent,
  UiFieldLabelComponent,
  UiDatepickerComponent,
  UiPullInboundShipmentsDialogComponent,
  UiMultipleConfirmationDialogComponent,
  UiFulfillmentActionConfirmationDialogComponent,
];

const lumModules = [MaterialCustomModule, DirectiveModule];

const libModules = [NgxScannerQrcodeModule];

const angularModules = [CommonModule, FormsModule, ReactiveFormsModule];

@NgModule({
  declarations: [...components],
  imports: [...angularModules, ...lumModules, ...libModules],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class UiModule {}
